<template>
  <div class="error-page">
    <div class="error-content">
      <h1 class="error-code">404</h1>
      <!-- <el-button type="primary" @click="goHome">返回</el-button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  methods: {
    goHome() {
      this.$router.push({
        name:'preferenceCosmos'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
  font-family: 'Arial', sans-serif;
}

.error-content {
  text-align: center;
  animation: fadeIn 1s ease-in-out;
}

.error-code {
  font-size: 120px;
  font-weight: bold;
  color: #2c3e50;
  margin: 0;
  animation: bounce 1.5s infinite;
}

.error-message {
  font-size: 24px;
  color: #34495e;
  margin: 10px 0;
}

.error-description {
  font-size: 16px;
  color: #7f8c8d;
  margin: 10px 0 20px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}
</style>